import React, { useState, useEffect, useCallback } from 'react';
import styles from './connectionStatus.module.css';

const ConnectionStatus = ({ socket }) => {
  const [status, setStatus] = useState('connected');
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [visible, setVisible] = useState(false);

  const handleOnline = useCallback(() => {
    setIsOnline(true);
    if (socket?.state === 'Connected') {
      setStatus('reconnected');
      setTimeout(() => setVisible(false), 3000);
    }
  }, [socket]);

  const handleOffline = useCallback(() => {
    setIsOnline(false);
    setStatus('offline');
    setVisible(true);
  }, []);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleOnline, handleOffline]);

  useEffect(() => {
    if (!socket) return;

    const onClose = (error) => {
      if (isOnline) {
        setStatus('disconnected');
        setVisible(true);
      }
    };

    const onReconnecting = (error) => {
      setStatus('reconnecting');
      setVisible(true);
    };

    const onReconnected = (connectionId) => {
      setStatus('reconnected');
      setTimeout(() => setVisible(false), 3000);
    };

    socket.onclose(onClose);
    socket.onreconnecting(onReconnecting);
    socket.onreconnected(onReconnected);
  }, [socket, isOnline]);

  useEffect(() => {
    if (!socket) return;

    const checkConnection = setInterval(() => {
      if (socket.state === 'Connected' && status === 'disconnected') {
        setStatus('reconnected');
        setTimeout(() => setVisible(false), 3000);
      } else if (socket.state !== 'Connected' && isOnline && status === 'connected') {
        setStatus('disconnected');
        setVisible(true);
      }
    }, 5000);

    return () => clearInterval(checkConnection);
  }, [socket, status, isOnline]);

  const getStatusConfig = () => {
    switch (status) {
      case 'offline':
      case 'disconnected':
      case 'reconnecting':
        return {
          message: 'Подключение',
          icon: '⟳',
          className: styles.reconnecting,
        };
      case 'reconnected':
        return {
          message: 'Соединение стабильное',
          icon: '🟢',
          className: styles.reconnected,
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();

  if (!visible || !config) return null;

  return (
    <div className={`${styles.container} ${config.className}`}>
      <div className={styles.content}>
        <span className={styles.icon}>{config.icon}</span>
        <span className={styles.message}>
          {config.message}
          {status !== 'reconnected' && (
            <span className={styles.dots}>
              <span className={styles.dot}>.</span>
              <span className={styles.dot}>.</span>
              <span className={styles.dot}>.</span>
            </span>
          )}
        </span>
      </div>
    </div>
  );
};

export default ConnectionStatus;

